import * as React from 'react';
import { useCallback } from 'react';
import Organisation from 'benchmarking-domain/organisation';
import { OrganisationForm } from 'components/admin/organisations/organisation-form';
import useApi from 'hooks/use-api';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

export default function AddOrganisation(): React.JSX.Element {
  const navigate = useNavigate();
  const { saveOrganisation } = useApi();

  const submitChanges = useCallback(
    async (data: Organisation) => {
      const newOrganisationId = await saveOrganisation({ ...data, id: '' });

      enqueueSnackbar('Organisation added!', { variant: 'success' });

      navigate(paths.app.admin.organisations.getDetailsUrl(newOrganisationId));
    },
    [navigate, saveOrganisation]
  );

  return <OrganisationForm onSubmit={submitChanges} />;
}
